module.exports = __webpack_public_path__ + "img/slider (3).236a7dd6.png";